import React, { ReactNode } from 'react'
import { IAppState } from '../../../../common/context/context'
import { locale, t, textWithLocale } from '../../../../common/i18n'
import * as CestaActions from '../../../../common/context/actions/cestaActions'
import { ProductInfo } from '../../../../common/context/actions/cestaActions'
import { DataSteps, Steps } from '../../../../common/components/cesta/Steps'
import { navigate } from 'gatsby'
import styles from './catalogoFicha.module.scss'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { selectPostCode } from '../../../../common/context/selectors/userSelectors'
import { CharacteristicsTable } from './CharacteristicsTable'
import { CatalogoProductInfo } from './CatalogoProductInfo'
import ResponsiveSliderBanner from '../../../../common/components/ResponsiveSliderBanner/ResponsiveSliderBanner'
import { getImages, ImageNode } from '../../../../common/utils/imagesS3'
import { Product } from '../../../../common/context/reducers/cestaReducer'
import { Descripcion } from './Descripcion'
import Gallery from './gallery/Gallery'
import { Specification } from '../especificaciones/Especificaciones'
import { Tag, Tags } from './Tags/Tags'
import { Destacamos } from '../../../../common/components/FichasNeumaticos/Info/Destacamos/Destacamos'
import {
  ConsumoLevels,
  LLuviaLevels,
  RuidoLevels,
} from '../../../../common/types/Ecolabel'
import SectionWithHeading from '../../../components/SectionWithHeading/SectionWithHeading'
import EcoLabels from '../../../../common/components/FichasNeumaticos/Info/EcoLabels/EcoLabels'
import WhiteBoxContainer from '../../../components/WhiteBoxContainer'
import { Documentos } from './documentos/Documentos'

interface ProductoFichaProps {
  catalogoProductInfo: CatalogoProductInfo
  producto?: Product
  specifications?: Array<Specification>
  tags?: Array<Tag>
  banners?: { [key: number]: ImageNode[] }
  cta: ReactNode
  children?: JSX.Element | JSX.Element[]
}

const CatalogoFicha: React.FC<ProductoFichaProps> = ({
  catalogoProductInfo,
  specifications = null,
  tags = null,
  banners = null,
  cta: Cta,
  children,
}) => {
  const bannerImagesDesktop = banners
    ? getImages(banners[`${locale}_desktop`], locale)
    : []
  const bannerImagesMobile = banners
    ? getImages(banners[`${locale}_mobile`], locale)
    : []

  return (
    <section className={styles.section_catalogo_ficha__container}>
      <WhiteBoxContainer>
        <div className={styles.catalogo_ficha__container}>
          {/* Top Section */}
          <div className={styles.catalogo_ficha__left_sidebar}>
            <Gallery producto={catalogoProductInfo} />
          </div>
          <div className={styles.catalogo_ficha__info}>
            <div>
              <h1>
                <span className={styles.producto_nombre_producto}>
                  {catalogoProductInfo.nombre_producto}
                </span>
              </h1>
              {catalogoProductInfo.producto && (
                <span className={styles.producto_descripcion}>
                  {catalogoProductInfo.producto[textWithLocale('descripcion')]}
                </span>
              )}
            </div>
            {tags && (
              <div className={styles.catalogo_ficha__tags}>
                <Tags tags={tags} />
              </div>
            )}
            {catalogoProductInfo.consumo && (
              <SectionWithHeading
                title={t('catalogo.producto.ficha.section_ecolabels.title')}>
                <div className={styles.catalogo_ficha__ecoLabels}>
                  <EcoLabels
                    consumo={catalogoProductInfo.consumo as ConsumoLevels}
                    lluvia={catalogoProductInfo.lluvia as LLuviaLevels}
                    ruido={catalogoProductInfo.nivel_ruido as RuidoLevels}
                    decibelios={catalogoProductInfo.decibelios}
                    eprel={catalogoProductInfo.eprel}
                  />
                </div>
              </SectionWithHeading>
            )}
            {Cta}
            <div className={styles.catalogo_ficha__destacamos}>
              <Destacamos producto={catalogoProductInfo} />
            </div>
          </div>

          <div className={styles.catalogo_ficha__content}>
            {/* Description */}
            <div className={styles.catalogo_ficha__descripcion}>
              <Descripcion producto={catalogoProductInfo} />
            </div>

            {/* Characteristics Table */}
            {specifications && (
              <div className={styles.catalogo_ficha__caracteristicas}>
                <CharacteristicsTable specifications={specifications} />
              </div>
            )}

            {/* Documentos Table */}
            {catalogoProductInfo.documentos && (
              <div className={styles.catalogo_ficha__caracteristicas}>
                <Documentos documents={catalogoProductInfo.documentos} />
              </div>
            )}

            {/* Promo Banner */}
            {bannerImagesDesktop.length || bannerImagesMobile.length ? (
              <div className={`${styles.catalogo_ficha__banner}`}>
                <ResponsiveSliderBanner
                  mobileImages={bannerImagesMobile}
                  desktopImages={bannerImagesDesktop}
                  sizesVariant={'banner_neumaticos'}
                />
              </div>
            ) : null}
            {children}
          </div>
        </div>
      </WhiteBoxContainer>
    </section>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    onSelectedNeumatico: (productInfo: ProductInfo) => {
      dispatch(CestaActions.addProduct(productInfo, 'database'))
      dispatch(CestaActions.setStep(Steps.TU_SOLICITUD))
      navigate(DataSteps[Steps.TU_SOLICITUD].route)
    },
  }
}

const mapStateToProps = (state: IAppState) => {
  return {
    postCode: selectPostCode(state),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CatalogoFicha)
